const DEFAULT_FALLBACK_LABELS: Record<string, string> = {
  TipoEntradaSalida: "Tipo Entrada/Salida",
  TipoConexion: "Tipo Conexion",
  TipoAcceso: "Tipo Acceso",
  /** Cabeçalho literal TieneTX (2 letras); não usar chave em ficheiros de idioma. */
  TX: "TX",
};

/** Sufixo fixo de campos de taxonomia; não entra nos JSON de idioma. */
export const TX_TAXONOMY_LABEL_SUFFIX = " TX";

export function appendTxTaxonomySuffix(baseLabel: string): string {
  const b = (baseLabel ?? "").trim();
  return b ? `${b}${TX_TAXONOMY_LABEL_SUFFIX}` : "TX";
}

export function txTaxonomyFieldLabel(
  translation: any,
  baseKey: string,
  fallback: string
): string {
  const base = String(translation?.[baseKey] ?? "").trim() || fallback;
  return appendTxTaxonomySuffix(base);
}

/**
 * A API pode devolver NivelNombre como "TX Nivel 1"; unifica para o mesmo padrão
 * visual que "Nivel 2 TX" (palavra(s) + número + sufixo literal TX).
 */
export function normalizeTaxonomiaNivelNombreForDisplay(
  raw: string | null | undefined
): string {
  const s = (raw ?? "").trim();
  if (!s) return "";
  const m = /^TX\s+(.+?)\s+(\d+)\s*$/i.exec(s);
  if (!m) return s;
  return `${m[1].trim()} ${m[2]} TX`;
}

export function resolveColumnLabel(
  key: string | null | undefined,
  translation: any,
  extraFallback?: Record<string, string>
): string {
  if (!key) {
    return "";
  }

  if (translation && translation[key]) {
    return translation[key];
  }

  const merged = { ...DEFAULT_FALLBACK_LABELS, ...extraFallback };
  if (merged[key]) {
    return merged[key];
  }

  const withSpaces = key
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/_/g, " ");

  return withSpaces
    .split(" ")
    .filter((segment) => segment.trim().length)
    .map((segment) =>
      segment
        .split("/")
        .map((part) =>
          part.length
            ? part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
            : part
        )
        .join("/")
    )
    .join(" ");
}
